// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2FA7z","paramInput":"JobSimulator_paramInput__1dJ0Y","input":"JobSimulator_input__1uNwp"};